<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountPeriodList' }">合作产品路径期间</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'partner_product_account_period' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['xxxxx'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="绩效分配" name="2" v-show="data.type_code == 1">
                    <vPerformanceAssignmentComponent
                        v-if="flag"
                        :postList="performance_assignment_params"
                    ></vPerformanceAssignmentComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vPerformanceAssignmentComponent from '../../listComponent/basicdata/performance/performanceAssignmentComponent.vue';
export default {
    inject: ['reload'],
    name: 'partnerProductAccountPeriodDetail',
    components: {
        draggableDetail,
        vPerformanceAssignmentComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '合作产品路径期间详情',
            flag: false,
            performance_assignment_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },

    methods: {
        in_array,
        initSubListParams() {
            this.performance_assignment_params.params = {
                object_rid: this.queryParams.rid,
                object_type_code: 8 // 目前只有8（应收、流向），传8便于新增按钮默认显示，后续如果放出6（应收）、7（流向），把这个 object_type_code去掉
            };
        },
        toDetail(prop) {},
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).partner_product_account_period;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(
                this.data.id,
                this,
                'partnerProductAccountPeriodDelete',
                this.data.rid,
                'partnerProductAccountDetail?id=' + this.$route.query.ppa_rid
            );
        },
        //编辑
        update() {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'update',
                    id: this.data.rid,
                    ppa_rid: this.data.ppa_rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'insert',
                    ppa_rid: this.$route.query.ppa_rid
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'partnerProductAccountPeriodEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid,
                    ppa_rid: this.data.ppa_rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .partnerProductAccountPeriodDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>